import React, { useState, useEffect } from 'react';
import { useUserProfile } from '../../helper/UserProfile';
import { useRevalidationData } from '../../helper/UserRevalidationProgress';
import { Link } from "react-router-dom";
import '../../stylesheets/revalidation.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { faSquareXmark } from '@fortawesome/free-solid-svg-icons';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { downloadRevalidationZip } from '../../helper/RevalidationPortfolioDownload';

function Platinum() {

     const { phlHours, totalHours, selectedQualifications, renewalDate, loading, feedback, reflective, phl, cpd, refresh } = useRevalidationData(); 

     const { profile } = useUserProfile();

     const [twoYear, setTwoYear] = useState("");
     const [oneYear, setOneYear] = useState("");
     const [threeMonth, setThreeMonth] = useState("");

     //Calculate days till renewal
     const today = new Date();
     const renewalDateObj = new Date(renewalDate);

     const diffInMs = renewalDateObj - today;
     const diffInDays = Math.ceil(diffInMs / (1000 * 60* 60 * 24));

     //Two Year Milestone Checker
     const checkTwoYear = () => {
        if (totalHours >= 12 && feedback.length >= 2 && reflective.length >= 2 && phlHours >= Number(selectedQualifications) * 450 / 3) {
            setTwoYear("Pass")
        } else {
            setTwoYear("Fail")
        }
     }

     //One Year Milestone Checker
     const checkOneYear = () => {
        if (totalHours >= 24 && feedback.length >= 4 && reflective.length >= 4 && phlHours >= (Number(selectedQualifications) * 450) / 3 * 2){
            setOneYear("Pass")
        } else {
            setOneYear("Fail")
        }
     }

     //Three Month Milestone Checker
     const checkThreeMonth = () => {
        if (totalHours >= 35 && feedback.length >= 5 && reflective.length >= 5 && phlHours.length >= Number(selectedQualifications) * 450){
            setThreeMonth("Pass")
        } else {
            setThreeMonth("Fail")
        }
     }

    //Download Form
    const downloadDiscussionForm = () => {
        const formUrl = '/reflective-discussion-form.doc';
        const link = document.createElement("a");
        link.href = formUrl;
        link.download = "Reflective Discussion Form.doc";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const downloadConfirmationStatement = () => {
        const formUrl = '/confirmation-form.doc';
        const link = document.createElement("a");
        link.href = formUrl;
        link.download = "onfirmation Form.doc";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


     useEffect(() => {
        refresh();
        checkTwoYear();
        checkOneYear();
        checkThreeMonth();
        }, []);

    if (loading) return <FontAwesomeIcon icon={faSpinner} style={{position: "absolute", top: "5rem", left: "50%", transform: "translate(-50%, 0)", fontSize: "40px"}}/>;

  return (
    <div>
        <div className="dashboard-body">
            <h1>YOUR REVALIDATION DASHBOARD</h1>
            <p className={!renewalDate ? "show error-message" : "hide"}>IMPORTANT! Please fill out your <Link to="/dashboard/details">revalidation details</Link>. Your app will not work if this is incomplete.</p>
            
            <h3>YOUR REVALIDATION MILESTONES</h3>
            <p>Your renewal date is {new Date(renewalDate).toLocaleString('en-GB', {day: '2-digit', month: 'long', year: 'numeric'})}, which is {diffInDays} days away.</p>

            <table className="reval-progress" style={{width: "100%"}}>
            <tr style={{height: "1rem"}}>
                <td style={{backgroundColor:"green"}}></td>
                <td className={diffInDays >= 730 ? "NA" : twoYear === "Pass" ? "pass" : "fail"}></td>
                <td className={diffInDays >= 365 ? "NA" : oneYear === "Pass" ? "pass" : "fail"}></td>
                <td className={diffInDays >= 90 ? "NA" : threeMonth === "Pass" ? "pass" : "fail"}></td>
            </tr>
            <tr>
                <td className="reval-bar">
                    3 years
                </td>
                <td className="reval-bar">
                    2 years
                    <ul>
                        <li>{totalHours >= 12 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}12 hours of CPD</li>

                        <li>{phlHours >= (Number(selectedQualifications) * 450) / 3 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}{(Number(selectedQualifications) * 450) / 3} of Practice Hours</li>

                        <li>{reflective.length >= 2 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}2 written reflective accounts</li>
                        <li>{feedback.length >= 2 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}2 practice related feedback</li>
                    </ul>
                </td>
                <td className="reval-bar">
                    12 months
                    <ul>
                        <li>{totalHours >= 24 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}24 hours of CPD</li>

                        <li>{phlHours >= (Number(selectedQualifications) * 450) / 3 * 2 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}{(Number(selectedQualifications) * 450) / 3 * 2} of Practice Hours</li>

                        <li>{reflective.length >= 4 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}4 written reflective accounts</li>

                        <li>{feedback.length >= 4 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}4 practice related feedback</li>
                    </ul>
                </td>
                <td className="reval-bar">
                    3 months
                    <ul>
                        <li>{totalHours >= 35 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}35 hours of CPD</li>

                        <li>{phlHours >= (Number(selectedQualifications) * 450) ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}{(Number(selectedQualifications) * 450)} of Practice Hours</li>

                        <li>{reflective.length >= 5 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}5 written reflective accounts</li>

                        <li>{feedback.length >= 5 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}5 practice related feedback</li>
                    </ul>
                </td>
            </tr>
            </table>

            <table className="reval-progress-mob">
            <tr>
                <td style={{backgroundColor:"green", width: "10px"}}></td>
                <td className="reval-bar">
                    3 years
                </td>
            </tr>
            <tr>
                <td className={diffInDays >= 730 ? "NA" : twoYear === "Pass" ? "pass" : "fail"}></td>
                <td className="reval-bar">
                    2 years
                    <ul>
                        <li>{totalHours >= 12 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}12 hours of CPD</li>

                        <li>{phlHours >= (Number(selectedQualifications) * 450) / 3 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}{(Number(selectedQualifications) * 450) / 3} of Practice Hours</li>

                        <li>{reflective.length >= 2 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}2 written reflective accounts</li>
                        <li>{feedback.length >= 2 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}2 practice related feedback</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <td className={diffInDays >= 365 ? "NA" : oneYear === "Pass" ? "pass" : "fail"}></td>
                <td className="reval-bar">
                    12 months
                    <ul>
                        <li>{totalHours >= 24 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}24 hours of CPD</li>

                        <li>{phlHours >= (Number(selectedQualifications) * 450) / 3 * 2 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}{(Number(selectedQualifications) * 450) / 3 * 2} of Practice Hours</li>

                        <li>{reflective.length >= 4 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}4 written reflective accounts</li>

                        <li>{feedback.length >= 4 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}4 practice related feedback</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <td className={diffInDays >= 90 ? "NA" : threeMonth === "Pass" ? "pass" : "fail"}></td>
                <td className="reval-bar">
                    3 months
                    <ul>
                        <li>{totalHours >= 35 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}35 hours of CPD</li>

                        <li>{phlHours >= (Number(selectedQualifications) * 450) ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}{(Number(selectedQualifications) * 450)} of Practice Hours</li>

                        <li>{reflective.length >= 5 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}5 written reflective accounts</li>

                        <li>{feedback.length >= 5 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}5 practice related feedback</li>
                    </ul>
                </td>
            </tr>
            </table>
    
            <br></br>
            <div className={threeMonth === "Pass" ? "show" : "hide"}>
                <p>Congratulations! You are ready for Revalidation. Please download your complete portfolio, as well as the <span onClick={() => downloadDiscussionForm()} className="clickable-link">Reflective Discussion</span> and <span onClick = {() => downloadConfirmationStatement()}className="clickable-link">Confirmation</span> templates.</p>

                
                <button onClick={() => downloadRevalidationZip(profile, phl, cpd)} className="reval">
                    Download Portfolio
                </button>
            </div>
            

            <div className={threeMonth === "Pass" ? "hide" : "show"}>
                <p>You are still missing documents to be eligible for revalidation. Please ensure you have uploaded the correct files and met the revalidation requirements.</p>
            </div>

        </div>
    </div>
  )
}

export default Platinum